var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u50A8\u80FD\u7AD9\u70B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0206098%",
    y1: "-32.9793902%",
    x2: "17.0206098%",
    y2: "119.959176%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7E9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-32.000000, -516.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u50A8\\u80FD\\u7AD9\\u70B9",
    transform: "translate(32.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32.561052,
    height: 32.561052
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4157796,13.2291797 L12.2429555,13.2291797 L12.2429555,9.15904822 L20.4157796,9.15904822 L20.4157796,13.2291797 Z M20.4157796,19.3506575 L12.2429555,19.3506575 L12.2429555,15.280526 L20.4157796,15.280526 L20.4157796,19.3506575 Z M20.4157796,25.4395742 L12.2429555,25.4395742 L12.2429555,21.3694427 L20.4157796,21.3694427 L20.4157796,25.4395742 Z M22.4345648,3.03757044 C22.9989564,3.03757044 23.5253601,3.14610728 24.0137758,3.36318096 C24.5021916,3.58025464 24.9309121,3.87330411 25.2999374,4.24232937 C25.6689626,4.61135462 25.9620121,5.04007514 26.1790858,5.52849092 C26.3961595,6.0169067 26.5046963,6.54331037 26.5046963,7.10770194 L26.5046963,27.4909205 C26.5046963,28.055312 26.3961595,28.5817157 26.1790858,29.0701315 C25.9620121,29.5585473 25.6689626,29.9872678 25.2999374,30.356293 C24.9309121,30.7253183 24.5021916,31.0183678 24.0137758,31.2354415 C23.5253601,31.4525151 22.9989564,31.561052 22.4345648,31.561052 L10.2241703,31.561052 C9.65977875,31.561052 9.13337508,31.4525151 8.6449593,31.2354415 C8.15654352,31.0183678 7.727823,30.7253183 7.35879775,30.356293 C6.98977249,29.9872678 6.69672302,29.5585473 6.47964934,29.0701315 C6.26257566,28.5817157 6.15403882,28.055312 6.15403882,27.4909205 L6.15403882,7.10770194 C6.15403882,6.54331037 6.26257566,6.0169067 6.47964934,5.52849092 C6.69672302,5.04007514 6.98977249,4.61135462 7.35879775,4.24232937 C7.727823,3.87330411 8.15654352,3.58025464 8.6449593,3.36318096 C9.13337508,3.14610728 9.65977875,3.03757044 10.2241703,3.03757044 L12.2429555,3.03757044 C12.2429555,2.47317888 12.4437487,1.99561678 12.845335,1.60488416 C13.2469213,1.21415153 13.7299102,1.01878522 14.2943018,1.01878522 L18.3644333,1.01878522 C18.9288249,1.01878522 19.4118138,1.21415153 19.8134001,1.60488416 C20.2149864,1.99561678 20.4157796,2.47317888 20.4157796,3.03757044 L22.4345648,3.03757044 Z M22.4345648,7.10770194 L10.2241703,7.10770194 L10.2241703,27.4909205 L22.4345648,27.4909205 L22.4345648,7.10770194 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.599a91488656c91c5b38522cdcbe40a4.svg";
export { ForwardRef as ReactComponent };